import { array, boolean, dateTime, defineAction, object, string } from '~/prix'
import systemSendEmailAction from './systemSendEmail.action.json'

const systemSendEmailDefinition = defineAction({
  ...systemSendEmailAction,
  input: object({
    emails: array(string()),
    subject: string(),
    subtitle: string(),
    sendAt: dateTime().isOptional(),
    notifications: array(
      object({
        title: string(),
        content: string(),
        color: string().isOptional(),
      }),
    ),
  }),
  output: object({
    warnings: array(
      object({
        message: string(),
      }),
    ),
    success: object({
      success: boolean(),
      id: string(),
    }),
  }),
})

export default systemSendEmailDefinition
